import axios from "axios";
import { endpoint } from "../../config/app.config";
import { clearCookie, getCookie, setParentDomainCookie } from "../../utils/cookies";

const { token, reset, sub, user } = getCookie()


export async function getContactDetails() {
  clearCookie()
  return axios
    .get(`${endpoint}/api/contact`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    });
}

export async function getManufacturersDetails() {
  clearCookie()
  return axios
    .get(`${endpoint}/api/manufacturer`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    });
}

export const getMembersDirectors = () => {
  clearCookie()
  return axios
    .get(`${endpoint}/api/employee`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getAdditionalResources = () => {
  clearCookie()
  return axios
    .get(`${endpoint}/api/resource`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    });
}

export const getFaqData = () => {
  clearCookie()
  return axios
    .get(`${endpoint}/api/faq`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    });
}
